var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { useLanguage } from '@base/LanguageProvider';
import { MessageStatus, } from '@common/api';
import FSButton from '@components/FSButton';
import { getClusterPathFromAnchor, useCommentsActions, useRepliesByMessageThreadId } from '@data/hooks/comments';
import { ArrowRight, ChevronLeft, ChevronRight, Close, Delete, Clock, Tick } from '@shared/icons/icons';
import { Status } from '@shared/status/status';
import UserAvatar from '@shared/userprofile/Avatar';
import { TagBadge } from '@styled/Basic';
import { FlexCol, FlexRow } from '@styled/FlexWrappers';
import { Comment, CommentAvatarBox, CommentAvatarLine, Message, MessageDate, MessageHeader, ShowRepliesBtn, } from '@styled/Sidebars';
import { appColors } from '@styled/useTheme';
import React, { useEffect, useRef, useState } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import FSToggle from '../../components/FSToggle';
import { downloadFarseerFile } from '../../data/farseerFile/farseerFileActions';
import { getFullName, getInitials } from '../../data/user/user';
import { ContextMenu } from '../../shared/contextmenu';
import { formatDateWithFormat } from '@util/date';
import { downloadFile } from '../../util/helpers';
import { Attachemnt, AttachmentInput } from './Attachments';
import { MentionInput, Mentions } from './Mentions';
export var COMMMENT_TEXTAREA = {
    padding: '8.5px 10px',
    flexGrow: 1,
    cursor: 'text',
    borderRadius: 5,
    maxWidth: 240,
    backgroundColor: appColors.neutral.w100,
};
var STATUS_COMMON_STYLE = {
    display: 'flex',
    fontSize: 11,
    textAlign: 'center',
    alignItems: 'center',
};
var MESSAGE = {
    margin: '11px 0px',
    maxWidth: 208,
    cursor: 'text',
};
var StatusMap = (_a = {},
    _a[MessageStatus.Resolved] = {
        status: 'Resolved',
        value: MessageStatus.Resolved,
        style: __assign(__assign({}, STATUS_COMMON_STYLE), { color: appColors.primary.w500, fontWeight: 'bold' }),
    },
    _a[MessageStatus.Unresolved] = {
        status: 'Unresolved',
        value: MessageStatus.Unresolved,
        default: true,
        style: __assign(__assign({}, STATUS_COMMON_STYLE), { color: appColors.neutral.w700 }),
    },
    _a[MessageStatus.InReview] = {
        status: 'In Review',
        value: MessageStatus.InReview,
        style: __assign(__assign({}, STATUS_COMMON_STYLE), { color: appColors.warning.w500, fontWeight: 'bold' }),
    },
    _a);
export var MessageThreadType;
(function (MessageThreadType) {
    MessageThreadType["General"] = "General";
    MessageThreadType["Cluster"] = "Cluster";
})(MessageThreadType || (MessageThreadType = {}));
function toMentionUser(user) {
    return {
        id: 'user' + user.id,
        itemId: user.id,
        name: "".concat(user.firstName, " ").concat(user.lastName),
        isGroup: false,
        userIds: null,
    };
}
function toMentionGroup(group) {
    return {
        id: 'group' + group.id,
        itemId: group.id,
        name: "".concat(group.name),
        isGroup: true,
        userIds: group.userIds,
    };
}
export function getMentionData(users, groups) {
    return users.map(toMentionUser).concat(groups.map(toMentionGroup));
}
export function createUserByIdMap(users) {
    return new Map(users.map(function (u) { return [u.id, u]; }));
}
function StatusOptions(_a) {
    var currentStatus = _a.currentStatus;
    return (React.createElement("div", null,
        React.createElement(Status, __assign({}, currentStatus))));
}
function ReplyItem(_a) {
    var _this = this;
    var _b, _c;
    var reply = _a.reply, isLastReply = _a.isLastReply, user = _a.user;
    var _d = __read(useState({}), 2), filesDownloadingById = _d[0], setFilesDownloadingById = _d[1];
    return (React.createElement(Message, null,
        React.createElement(CommentAvatarBox, null,
            React.createElement(UserAvatar, { size: 32, initials: getInitials(user) }),
            isLastReply ? null : React.createElement(CommentAvatarLine, null)),
        React.createElement(FlexCol, { style: { flexGrow: 1 } },
            React.createElement(MessageHeader, null,
                React.createElement("label", { style: { fontWeight: 'bold' } }, getFullName(user))),
            React.createElement(MessageHeader, null,
                React.createElement(MessageDate, null, formatDateWithFormat(reply.creationTime, 'HH:mm, MMM Do', true))),
            React.createElement(Mentions, { style: MESSAGE, rawContent: reply.content, footer: !!((_b = reply.files) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginTop: 8 } }, (_c = reply === null || reply === void 0 ? void 0 : reply.files) === null || _c === void 0 ? void 0 : _c.map(function (f) { return (React.createElement(Attachemnt, { key: f.id, id: f.id, name: f.name, loading: !!(filesDownloadingById === null || filesDownloadingById === void 0 ? void 0 : filesDownloadingById[f.id]), onDownload: function (id) { return __awaiter(_this, void 0, void 0, function () {
                        var blob;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    setFilesDownloadingById(__assign(__assign({}, filesDownloadingById), (_a = {}, _a[id] = true, _a)));
                                    return [4 /*yield*/, downloadFarseerFile(id)];
                                case 1:
                                    blob = _c.sent();
                                    downloadFile(blob, f.name);
                                    setFilesDownloadingById(__assign(__assign({}, filesDownloadingById), (_b = {}, _b[id] = false, _b)));
                                    return [2 /*return*/];
                            }
                        });
                    }); } })); }))) }))));
}
function createMessageKey(message) {
    return message.creationTime.toISOString() + message.creatorId;
}
export default function CommentThread(_a) {
    var _b;
    var _this = this;
    var _c, _d, _e, _f;
    var messageThread = _a.messageThread, mentionData = _a.mentionData, currentUser = _a.currentUser, _g = _a.addMargins, addMargins = _g === void 0 ? false : _g, _h = _a.showBadges, showBadges = _h === void 0 ? [] : _h, _j = _a.arrows, arrows = _j === void 0 ? null : _j, _k = _a.maxHeight, maxHeight = _k === void 0 ? null : _k, userMapById = _a.userMapById;
    var L = useLanguage().L;
    var toggleRef = useRef(null);
    var _l = __read(useState([]), 2), attachments = _l[0], setAttachments = _l[1];
    var _m = __read(useState(false), 2), showReplies = _m[0], setShowReplies = _m[1];
    var _o = useCommentsActions(), appendMessageToThread = _o.appendMessageToThread, changeCommentStatus = _o.changeCommentStatus, readComment = _o.readComment, removeMessageThread = _o.removeMessageThread, isAppendingMessageThread = _o.isAppendingMessageThread;
    var _p = __read(useState({}), 2), filesDownloadingById = _p[0], setFilesDownloadingById = _p[1];
    var user = userMapById.get((_c = messageThread.creatorId) !== null && _c !== void 0 ? _c : 0);
    var replies = useRepliesByMessageThreadId(messageThread.id);
    var initialMessage = messageThread.metadata.initialMessage;
    var initialMessageKey = createMessageKey(initialMessage);
    var lastMessage = messageThread.metadata.lastMessage;
    var status = StatusMap[initialMessage.status || MessageStatus.Unresolved];
    useEffect(function () {
        if (currentUser === undefined) {
            return;
        }
        var cursorForCurrUser = messageThread.metadata.cursors[currentUser.id];
        if (cursorForCurrUser === undefined || cursorForCurrUser < lastMessage.order) {
            readComment({ messageThread: messageThread, lastMessageOrder: lastMessage.order });
        }
    }, []);
    function createReplyHandler(mentionedUserIds, mentionedGroupIds, rawContent) {
        return __awaiter(this, void 0, void 0, function () {
            var content;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((!rawContent.blocks.some(function (b) { return !!b.text; }) && !attachments.length) || isAppendingMessageThread) {
                            return [2 /*return*/];
                        }
                        content = JSON.stringify(rawContent);
                        return [4 /*yield*/, appendMessageToThread({
                                threadId: messageThread.id,
                                anchor: messageThread.anchor,
                                message: {
                                    content: content,
                                    mentionedUserIds: mentionedUserIds,
                                    mentionedUserGroupIds: mentionedGroupIds,
                                },
                                files: attachments.length ? attachments : undefined,
                            })];
                    case 1:
                        _a.sent();
                        setAttachments([]);
                        return [2 /*return*/];
                }
            });
        });
    }
    var actionsMap = (_b = {},
        _b[MessageStatus.Resolved] = [
            {
                actionName: L('Mark as in Review'),
                icon: Clock,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.InReview });
                },
            },
            {
                actionName: L('Mark as Unresolved'),
                icon: Close,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.Unresolved });
                },
                break: true,
            },
        ],
        _b[MessageStatus.InReview] = [
            {
                actionName: L('Mark as Resolved'),
                icon: Tick,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.Resolved });
                },
                creative: true,
            },
            {
                actionName: L('Mark as Unresolved'),
                icon: Close,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.Unresolved });
                },
                break: true,
            },
        ],
        _b[MessageStatus.Unresolved] = [
            {
                actionName: L('Mark as Resolved'),
                icon: Tick,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.Resolved });
                },
                creative: true,
            },
            {
                actionName: L('Mark as in Review'),
                icon: Clock,
                action: function () {
                    changeCommentStatus({ messageThread: messageThread, status: MessageStatus.InReview });
                },
                break: true,
            },
        ],
        _b);
    var contextMenuItems = messageThread.anchor
        ? __spreadArray(__spreadArray([], __read(actionsMap[initialMessage.status]), false), [
            {
                icon: ArrowRight,
                actionName: L('Go to Row'),
                action: function () {
                    var _a;
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            if (!!((_a = messageThread.anchor) === null || _a === void 0 ? void 0 : _a.length)) {
                                location.hash = '/sheet/' + getClusterPathFromAnchor(messageThread.anchor);
                            }
                            return [2 /*return*/];
                        });
                    });
                },
                break: true,
            },
            {
                icon: Delete,
                actionName: L('Delete Thread'),
                action: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, removeMessageThread(messageThread)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
                isDisabled: messageThread.creatorId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
                destructive: true,
            },
        ], false) : __spreadArray(__spreadArray([], __read(actionsMap[initialMessage.status]), false), [
        {
            icon: Delete,
            actionName: L('Delete Thread'),
            action: function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, removeMessageThread(messageThread)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            isDisabled: messageThread.creatorId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
            destructive: true,
        },
    ], false);
    return (React.createElement(Comment, { "$mention": false, "$addMargins": addMargins },
        showBadges.length > 0 && (React.createElement(FlexRow, null, showBadges.map(function (label, idx) {
            return (React.createElement(TagBadge, { key: idx, style: { marginRight: 10, marginBottom: 10 } }, label));
        }))),
        React.createElement("div", { style: maxHeight ? { maxHeight: maxHeight, overflow: 'auto' } : {} },
            React.createElement(Message, null,
                React.createElement(CommentAvatarBox, null,
                    React.createElement(UserAvatar, { color: "white", backgroundColor: appColors.ui.dark, size: 32, initials: getInitials(user) }),
                    React.createElement(CommentAvatarLine, null)),
                React.createElement(FlexCol, { style: { flexGrow: 1 } },
                    React.createElement(MessageHeader, null,
                        React.createElement("label", { style: { fontWeight: 'bold' } }, getFullName(user)),
                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                            React.createElement(StatusOptions, { currentStatus: status }),
                            React.createElement(FSToggle, { disabled: isAppendingMessageThread, readOnly: true, style: { marginLeft: 10 }, "$size": "small", ref: toggleRef, icon: FaEllipsisH, "$color": "neutral" }),
                            React.createElement(ContextMenu, { triggerRefs: [{ ref: toggleRef, trigger: 'click' }], items: contextMenuItems }))),
                    React.createElement(MessageHeader, null,
                        React.createElement(MessageDate, null, formatDateWithFormat(initialMessage.creationTime, 'HH:mm, MMM Do', true))),
                    React.createElement(Mentions, { key: messageThread.id, style: MESSAGE, rawContent: initialMessage.content, footer: !!((_d = messageThread.metadata.initialMessage.files) === null || _d === void 0 ? void 0 : _d.length) && (React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginTop: 8 } }, (_f = (_e = messageThread.metadata.initialMessage) === null || _e === void 0 ? void 0 : _e.files) === null || _f === void 0 ? void 0 : _f.map(function (f) { return (React.createElement(Attachemnt, { key: f.id, id: f.id, name: f.name, loading: !!(filesDownloadingById === null || filesDownloadingById === void 0 ? void 0 : filesDownloadingById[f.id]), onDownload: function (id) { return __awaiter(_this, void 0, void 0, function () {
                                var blob;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            setFilesDownloadingById(__assign(__assign({}, filesDownloadingById), (_a = {}, _a[id] = true, _a)));
                                            return [4 /*yield*/, downloadFarseerFile(id)];
                                        case 1:
                                            blob = _c.sent();
                                            downloadFile(blob, f.name);
                                            setFilesDownloadingById(__assign(__assign({}, filesDownloadingById), (_b = {}, _b[id] = false, _b)));
                                            return [2 /*return*/];
                                    }
                                });
                            }); } })); }))) }))),
            showReplies &&
                replies.map(function (reply, idx) {
                    var _a;
                    var currentMessageKey = createMessageKey(reply);
                    if (currentMessageKey !== initialMessageKey) {
                        return (React.createElement(ReplyItem, { key: currentMessageKey, reply: reply, isLastReply: idx === replies.length - 1, user: userMapById.get((_a = reply.creatorId) !== null && _a !== void 0 ? _a : 0) }));
                    }
                }),
            !showReplies && (React.createElement(React.Fragment, null,
                replies.length > 5 && (React.createElement(ShowRepliesBtn, { onClick: function () { return setShowReplies(true); } }, "...")),
                replies.slice(-5).map(function (reply, idx) {
                    var _a;
                    var currentMessageKey = createMessageKey(reply);
                    if (currentMessageKey !== initialMessageKey) {
                        return (React.createElement(ReplyItem, { key: currentMessageKey, reply: reply, isLastReply: idx === replies.length - 1, user: userMapById.get((_a = reply.creatorId) !== null && _a !== void 0 ? _a : 0) }));
                    }
                }))),
            React.createElement(FlexRow, null,
                React.createElement(CommentAvatarBox, null,
                    React.createElement(UserAvatar, { size: 32, initials: "".concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstName[0]).concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastName[0]) })),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexGrow: 1 } },
                    React.createElement(MentionInput, { mentionData: mentionData, style: COMMMENT_TEXTAREA, placeholder: L('Reply or tag others with @...'), onDone: createReplyHandler, footer: !!attachments.length && (React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginTop: 8 } }, attachments.map(function (a, idx) { return (React.createElement(Attachemnt, { loading: isAppendingMessageThread, key: idx, id: idx, name: a.name, onRemove: function (id) {
                                return setAttachments(attachments.filter(function (a, i) { return i !== id; }));
                            } })); }))) }),
                    React.createElement(AttachmentInput, { disabled: isAppendingMessageThread, onChange: function (e) {
                            var _a, _b, _c;
                            var files = [];
                            for (var i = 0; i < ((_b = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); i++) {
                                var file = (_c = e.target.files) === null || _c === void 0 ? void 0 : _c.item(i);
                                if (file) {
                                    files.push(file);
                                }
                            }
                            setAttachments(__spreadArray(__spreadArray([], __read(attachments), false), __read(files), false));
                        } })))),
        arrows && (React.createElement(FlexRow, { style: { alignItems: 'center' } },
            React.createElement("div", { style: { flexGrow: 1, paddingLeft: 44 } }, "".concat(L('Comment'), " ").concat(arrows.current, " ").concat(L('of'), " ").concat(arrows.all)),
            React.createElement(FSButton, { "$size": "small", "$type": "tertiary", onClick: function () { return arrows.action(arrows.current - 1); }, icon: ChevronLeft }),
            React.createElement(FSButton, { "$size": "small", "$type": "tertiary", onClick: function () { return arrows.action(arrows.current + 1); }, icon: ChevronRight })))));
}
